



















































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import Emit from "vue-property-decorator";
import { StringHelpers } from "../../api/helpers/StringHelpers";
import { status } from "../../api/status/status";
import { workorder } from "../../api/workorder/workorder";
import { personnel } from "../../api/personnel/personnel";
import { vacation } from "../../api/vacation";
import { postgrest } from "../../api/postgrest";

import Moment from "moment";

@Component({
  name: "AddNewVacation"
})
export default class AddNewVacation extends Vue {
  public id: any = "";
  public name: any = "";
  public total: any[] = [];
  public leaveOn: any = "";
  public ReturnOn: any = "";
  public leaveEnd: any= "";
  public json_leaveon_leaveend: any="";
  public year_vacation: any = "";
  public type: any = "";
  public types: any[] = [];
  public remarks: string = "";
  public DateOfRequest: any = "";
  public availableName: any[] = [];
  public availableType: any[] = [];
  public personnelList: any[] = [];
  public typeList: any[] = [];
  public loading: boolean = false;
  public total_days_req: any = "";  
  public row: any = "";
  public leave_on_end: any[] =[];
  
  // public leaveon: any = "";
  
  
  public pushVacation() {
    // console.log(this.leave_on_end[0].leaveon)
    // console.log("this.leave_on_end")
    // this.leave_on_end.push({leave_on:this.leave_on_end})
    if(this.leaveOn!= "" && this.leaveEnd!= ""){
    
    // console.log("this.leaveOn----->"+ typeof this.leaveOn)
   

    // this.leaveOn.setHours(this.leaveOn.getHours() + 4);

    // this.leaveEnd.setHours(this.leaveOn.getHours() + 4);
    
    //auto xalage to sort
    // let x = this.leaveOn.toLocaleDateString();
    // let y = this.leaveEnd.toLocaleDateString();
    //commitnexttime!!!!!
    let x = Moment(this.leaveOn).format("YYYY-MM-DD")
    let y = Moment(this.leaveEnd).format("YYYY-MM-DD")
    console.log('x is:'+   x);

    console.log("this.leaveOn2----->"+ this.leaveOn)
   
     
  

    this.leave_on_end.push({leave_on: x , leave_end: y})
    console.log(JSON.stringify(this.leave_on_end));
    this.leaveOn=""
    this.leaveEnd=""
    
    }
     
      
  }
  
   public vacationUpdate(  k: number) {
    if (this.leave_on_end[k].leave_on == null && this.leave_on_end[k].leave_end == null ) {
      this.leave_on_end.splice(k, 1);
    }
    console.log(this.leave_on_end);
  }
  public testme() {
  
    //console.log(JSON.stringify(this.name));
  }

  public addToDBVacationDecision() {
    if (this.row.id == undefined) {
      this.addToDBVacation();
    } else {
      this.addToDBVacation2();
    }
  }

  public addToDBVacation() {
    //dimiourgia item. aristera idia met me api front, deksia idia met m v-model tou idiou
    // console.log(JSON.stringify(this.leave_on_end))
    // console.log("this.leave_on_end")
    //  console.log('testforvacationfrontend1')
    // console.log(this.leave_on_end[0].leave_on)    
    // console.log(this.leave_on_end[0].leave_end)
    // console.log(Moment(this.ReturnOn).format("YYYY/MM/DD"))
    // console.log('testforvacationfrontend2')
    let a = Moment(this.leave_on_end[0].leave_on).format("YYYY/MM/DD")
    a=a.replace("/","-")
    a=a.replace("/","-")
    //  console.log('replaced a'+a)
    let b = Moment(this.leave_on_end[0].leave_end).format("YYYY/MM/DD")
    b=b.replace("/","-")
    b=b.replace("/","-")
    //  console.log('replaced b'+b)
    let c = Moment(this.ReturnOn).format("YYYY/MM/DD")
    c=c.replace("/","-")
    c=c.replace("/","-")
    // console.log('replaced c'+c)
    if((a <= b)&&(a < c )&& (b<c)){
  
    
    let vacationItem: any[] = [
      {
        idper: this.name.id,
        total_days_req: this.total_days_req,
        // leaveOn: this.leaveOn,
        leaveOn: this.leave_on_end[0].leave_on,               
        ReturnOn: this.ReturnOn,
        type: this.type.id,
        remarks: this.remarks,
        DateOfRequest: this.DateOfRequest,
        leaveEnd: this.leave_on_end[0].leave_end,
        json_leaveon_leaveend: JSON.stringify(this.leave_on_end),
        year_vacation: this.year_vacation
      }
    ];
   
    //api front addVacation
    vacation
      .addVacation(
        this.$store.getters.getToken,
        vacationItem,
        this.$store.getters.getHost
      )
      .then(r => {
        if (r.status == 400) {
          this.$message.error(r.error);
        } else {
          /* this.$store.dispatch("updateCurrentObject", {});
            this.$store.dispatch("updateCurrentComponent", "ShiftList"); */
          this.$message.success("Vacation Added");
          this.$router.replace({
            name: "load"
          });
          //this.$store.dispatch("updateCurrentObject", {});
        }
      });
      }else{
  
            this.$notify.error({
          title: 'Error',
          message: 'Incorrect dates'
        });
    }
  }
  public addToDBVacation2() {
    let vacationItem: any[] = [
      {
        id: this.row.id,
        idper: this.name.id,
        total_days_req: this.total_days_req,
        // leaveOn: this.leaveOn,
        leaveOn: this.leave_on_end[0].leave_on,        
        ReturnOn: this.ReturnOn,
        type: this.type.id,
        remarks: this.remarks,
        DateOfRequest: this.DateOfRequest,
        leaveEnd: this.leave_on_end[0].leave_end,
        json_leaveon_leaveend: JSON.stringify(this.leave_on_end),
        year_vacation: this.year_vacation
      }
    ];

    //api front addVacation
    //console.log("Frontend token:" + this.$store.getters.getToken);
    vacation
      .addVacation2update(
        this.$store.getters.getToken,
        vacationItem,
        this.$store.getters.getHost
      )
      .then(r => {
        //console.log("r =====> " + JSON.stringify(r));
        if (r.status == 400) {
          this.$message.error(r.error);
        } else {
          /* this.$store.dispatch("updateCurrentObject", {});
            this.$store.dispatch("updateCurrentComponent", "ShiftList"); */
          this.$message.success("Vacation Added");
          this.$router.replace({
            name: "load"
          });
        }
      });
  }
  //apla gemizi tin forma tou add
  //gia to edit
  public async checkEdit() {
    this.row = this.$store.getters.getCurrentObject; 
    console.log(JSON.stringify(this.row))
    console.log(JSON.stringify('this.rowvacation'))
    if (this.row.id != undefined) {
      let met = this.row.idpersonel;
      let xxx: any = {
        key: this.row.idpersonel,
        label:
          this.personnelList.find(function(element) {
            return met == element.id;
          }).firstname +
          " " +
          this.personnelList.find(function(element) {
            return met == element.id;
          }).lastname,
        value: this.row.idpersonel,
        id: this.row.idpersonel
      };
      this.name = {};
      Vue.set(this.name, "key", xxx.key);
      Vue.set(this.name, "value", xxx.value);
      Vue.set(this.name, "label", xxx.label);
      Vue.set(this.name, "id", xxx.id);
     
      
      this.year_vacation = this.row.year_vacation;
      this.total_days_req = this.row.total_days_req;            
      // this.leaveOn = new Date(this.row.leave_on);
      // this.leaveOn = new Date(this.row.leave_on_end[0].leave_on)      
      // this.leaveEnd = new Date(this.row.leave_end)
      //new

      let x=JSON.parse(this.row.json_leaveon_leaveend)    
    this.leave_on_end=x

    // let temp=""
    // let temp2=""
    // for(let c in x){
    //  temp+=Moment( x[c].leave_on  ).format("DD/MM/YYYY")+ "\n"
    //  this.leaveOn = new Date(this.row.leave_on);
    //  temp2+=Moment( x[c].leve_end).format("DD/MM/YYYY")+ "\n"
    //  this.leaveEnd= new Date(this.row.leave_end);
     
    // }
   
      this.ReturnOn = new Date(this.row.return_on);
      this.remarks = this.row.remarks;
      this.DateOfRequest = new Date(this.row.date_of_request);

      let met2 = this.row.type_of_vacation;
      let yyy: any = null;
      //console.log("ROOOOOW:" + JSON.stringify(this.row));
      try {
        //console.log("typeList ====> " + JSON.stringify(this.typeList));
        let result: any = this.typeList.find(function(element) {
          return met2 == element.id;
        });
        //console.log("result => " + JSON.stringify(result));
        result = result.type_of_vacation;
        yyy = {
          key: this.row.type_of_vacation,
          label: result,
          value: this.row.type_of_vacation,
          id: this.row.type_of_vacation
        };
      } catch (ex) {
        // console.log("Exception:" + ex);
      }

      this.type = {};
      Vue.set(this.type, "key", yyy.key);
      Vue.set(this.type, "label", yyy.label);
      Vue.set(this.type, "value", yyy.value);
      Vue.set(this.type, "id", yyy.id);
    }
    this.$store.dispatch("updateCurrentObject", {});
  }
  //rows atofia
  public nameMethod(query: string) {
    this.loading = false;
    this.availableName = this.personnelList.filter(item => {
      return (
        (item.firstname.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
          item.lastname.toLowerCase().indexOf(query.toLowerCase()) > -1) &&
        (item.active || this.$store.getters.getUserLevel < 1)
      );
    });
  }
  public async getPersonnelList() {

    this.personnelList= await postgrest.get('personnel?select=*,companies(*),wo_specialties(*),specialties(*)',this.$store.getters.getToken)
    //  console.log('getpersonnellistforpostgrest1')
    // console.log(JSON.stringify(resp))
    // console.log('getpersonnellistforpostgrest2')
    // await personnel
    //   .getAllPersonnel(
    //     this.$store.getters.getToken,
    //     this.$store.getters.getHost
    //   )
    //   .then(response => {
    //     response.json().then(resp => {
    //       this.personnelList = JSON.parse(JSON.stringify(resp));
    //       console.log('testforpersonnellistpostgrest1')
    //       console.log(JSON.stringify(this.personnelList))
    //       console.log('testforpersonnellistpostgrest2')
    //     });
    //   });
   
  }
  //row.id h grammh ths eggrafhs pou thelw

  public exportVA(id: any) {
    this.$store.dispatch("setCurrentId", id);
    this.$store.dispatch("updateCurrentComponent", "DownloadVacation");
    this.$router.replace({
      name: "load"
    });
  }

  public async getTypeList() {
    //to arxio tou api einai to vacation
    let resp = await postgrest.get('type_vacation',this.$store.getters.getToken)
    this.typeList = JSON.parse(JSON.stringify(resp));
    // let response: any = await vacation.getAllType(
    //   this.$store.getters.getToken,
    //   this.$store.getters.getHost
    // );
    // let resp: any = await response.json();
    // this.typeList = JSON.parse(JSON.stringify(resp));

    // // .then(response => {
    // //   response.json().then(resp => {
    // //     this.typeList = JSON.parse(JSON.stringify(resp));
    // //     console.log(this.typeList);
    // //     console.log('testtypelist')
    // //   });
    // // });
  }
  //energop automata
  public async created() {
    await this.getPersonnelList();
    await this.getTypeList();
    this.nameMethod("");
    this.checkEdit();
  }
}
